import { render, staticRenderFns } from "./infoItem.vue?vue&type=template&id=74e5f385&"
import script from "./infoItem.vue?vue&type=script&lang=js&"
export * from "./infoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports